var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "423px",
    height: "117px",
    viewBox: "0 0 423 117",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bottomImage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "67.4620311%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M300.55852,29.5830113 C287.98705,35.3896593 275.658779,32.1844296 259.991211,21.720968 C213.804155,-9.12589278 181.116775,-4.9401333 138.081941,22.9114105 C128.91275,28.8458179 114.111653,38.7117154 89.3004613,31.6908848 C52.9891184,21.4157824 15.6438719,31.805837 0.01558962,60.389264 L411.796694,60.389264 C400.076418,38.0582372 356.235289,3.8699533 300.55852,29.5830113",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "96.570732%",
    y1: "121.693594%",
    x2: "9.03769999%",
    y2: "33.4890828%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C8EB8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5F9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.067035366,33.2130644 C1.8626478,29.8816371 10.8382156,23.3309236 22.2292392,25.1058105 C34.6632083,27.0440671 37.3954451,22.8167624 42.5213121,21.0590557 C51.9065752,17.8410189 59.1501362,28.4581666 62.3940243,21.7215927 C66.5358746,13.1211065 73.2593659,8.86974929 93.7622105,17.329669 C98.632096,19.3391459 98.2981663,14.8872471 100.51501,12.2873907 C104.819928,7.23917731 110.033097,16.5574901 112.425168,16.0461402 C115.141192,15.4651318 114.312136,11.4986561 115.902901,8.10225593 C119.21663,1.02582344 124.935838,7.67649547 128.878453,7.09236336 C132.803919,6.51135495 134.9054,-1.27696901 139.350001,0.297688715 C148.845638,3.6609777 145.865215,23.4327562 145.27811,27.8434222 C147.978544,24.0796747 152.733378,21.315824 152.733378,33.2130644 L0.067035366,33.2130644",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.7292915%",
    y1: "107.912713%",
    x2: "33.318513%",
    y2: "-2.07974657%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5C79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC3D1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.970921533,18.5316692 L47.0313892,18.5316692 C49.4250194,9.02156116 40.023855,13.7767714 40.023855,13.7767714 C40.023855,13.7767714 43.5673756,3.77343094 39.9356178,4.81206155 C36.4285768,5.81445724 34.8901931,13.6065296 34.8901931,13.6065296 C34.8901931,13.6065296 33.0007312,0.881196082 28.8576338,0.0471678867 C26.1681125,-0.494481885 28.2786353,12.1461994 28.2786353,12.1461994 C28.2786353,12.1461994 26.691612,10.7958234 24.4080444,10.7611503 C22.489274,10.7320999 22.9538447,13.2004485 22.9538447,13.2004485 C22.9538447,13.2004485 18.9516774,4.99323622 16.867657,5.10006679 C14.2542131,5.2337612 17.056915,13.855801 17.056915,13.855801 C17.056915,13.855801 11.9110933,8.25000699 9.88381908,8.39713331 C7.06646295,8.60111099 11.9781286,16.6065322 11.9781286,16.6065322 C11.9781286,16.6065322 8.2459736,14.3605911 3.80542624,14.7313744 C0.601447539,14.9987632 -0.627949893,16.293225 0.970921533,18.5316692",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "97.8075118%",
    y1: "127.081248%",
    x2: "31.2342438%",
    y2: "48.0747459%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC3D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE2EF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.2653918,35.998781 C26.2653918,55.788677 18.4051054,71.9738219 12.9549742,71.9738219 C7.50172514,71.9738219 0.277495236,50.3681185 0.277495236,30.5785349 C0.277495236,10.7886389 9.10433808,-1.97136777 15.4461955,0.308934039 C22.5955952,2.8781782 26.2653918,16.2091974 26.2653918,35.998781",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.114817%",
    y1: "92.5251212%",
    x2: "-1.29058188%",
    y2: "5.37581688%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6373",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ED1D1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-14",
    points: "42.1169174 71.3222179 0.0395976348 71.3222179 0.0395976348 29.1678714 21.0777898 0.153061354 42.1169174 29.1678714 42.1169174 71.3222179"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.06219943%",
    y1: "18.1332186%",
    x2: "78.7259268%",
    y2: "101.696835%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "0.165249972 0.0203040572 48.4650106 0.0203040572 48.4650106 34.4625448 0.165249972 34.4625448"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-23.7686399%",
    y1: "-29.0627692%",
    x2: "98.4003615%",
    y2: "101.867478%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.1511153%",
    y1: "149.195092%",
    x2: "59.0462457%",
    y2: "-3.24412077%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CE8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97D61",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-21",
    points: "0.187699025 0.153061354 49.8119538 0.153061354 70.848587 29.1678714 21.2268266 29.1678714 0.187699025 0.153061354"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.6846815%",
    y1: "116.887367%",
    x2: "57.3538574%",
    y2: "-42.5887647%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95E36",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80331A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-24",
    points: "13.9246486 0.181174664 0.246315996 0.181174664 13.9246486 20.1091382 13.9246486 0.181174664"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "19.398222%",
    y1: "-25.1128597%",
    x2: "85.656713%",
    y2: "36.6374067%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.3840111,16.8651746 C50.2914905,15.099034 48.0762055,13.4141097 45.2728801,13.0036553 C40.5984884,12.3198772 42.2026603,7.13484569 38.1396935,5.7626038 C33.8553542,4.31508071 33.4942986,7.76614569 22.5376018,1.54404546 C19.4745533,-0.195856059 13.7936958,-0.741566642 11.271607,2.56424624 C9.79527004,4.4990667 9.43359085,7.31289666 9.86729408,9.65567249 C10.2841605,11.9103599 11.9687749,15.1646318 10.1382417,17.1906643 C8.39968725,19.1148642 5.34193919,18.5060548 3.224557,19.7277343 C1.07318944,20.9687808 0.243821657,23.4777375 0.211083455,25.8408174 C0.134382524,31.3603972 2.4983925,37.3116726 5.99950936,41.5230464 C13.2963869,50.2993971 26.4446724,52.3975871 36.8273593,48.6179087 C42.9628102,46.3847748 47.763166,41.836666 50.5646207,35.9494265 C53.2310693,30.3470686 54.8567548,22.4844006 51.3840111,16.8651746",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.8431864%",
    y1: "97.9762099%",
    x2: "32.3900053%",
    y2: "9.83646204%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6373",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ED1D1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.1143719,5.38182463 C32.8011841,5.49146654 30.3904052,6.00656486 22.5366665,1.54279598 C19.4754887,-0.195543689 13.7952547,-0.740629532 11.2709835,2.56487098 C9.796829,4.49969144 9.43390264,7.31289666 9.86854125,9.6566096 C10.2841605,11.9094228 11.970022,15.1655689 10.1369945,17.1916014 C8.39844008,19.1148642 5.34100381,18.5054301 3.224557,19.7283591 C1.07412482,20.9700303 0.242574487,23.4768004 0.212642417,25.8392555 C0.133135355,31.3597725 2.49901609,37.311985 5.99857398,41.5221093 C6.33499798,41.9272533 6.68264651,42.3174036 7.04557286,42.6919354 C20.2237904,49.8745737 10.6810722,27.97493 15.0801512,23.9990832 C17.8657045,21.4813801 23.3117824,25.0480221 25.7796192,23.2800072 C27.011511,22.397874 26.9132964,20.6520375 25.9532876,19.323215 C22.9903244,15.2299171 18.2283191,10.8720417 20.5829753,8.39557146 C21.8413694,7.07049745 24.3472449,7.7973827 29.0674701,7.81268883 C34.5210309,7.82799497 37.3327748,6.41920577 35.1143719,5.38182463",
    id: "path-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.139965%",
    y1: "82.0872418%",
    x2: "28.6343314%",
    y2: "4.5863415%",
    id: "linearGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC3D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE2EF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.6326325,16.3450784 C79.2576281,13.0136512 72.3919594,6.46293759 63.6804798,8.23782456 C54.1676936,10.1760811 52.0786846,5.94877639 48.1563362,4.19106977 C40.9788751,0.973032894 37.4431493,8.95721292 32.9564567,4.85360678 C26.6894294,-0.87588579 21.6134492,-1.46033027 17.5663838,3.81966171 C11.7483376,11.4121296 2.21060812,3.00468809 0.068594328,16.3450784 L80.6326325,16.3450784",
    id: "path-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.1335191%",
    y1: "116.065945%",
    x2: "48.3913077%",
    y2: "-93.8539499%",
    id: "linearGradient-35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5C79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC3D1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.3643476,16.9698186 L0.074830176,16.9698186 C0.28061316,5.8441324 3.20210795,12.9861626 3.20210795,12.9861626 C3.20210795,12.9861626 4.16242854,4.855481 6.28573478,4.52593053 C8.29055991,4.21449753 9.23529089,12.502926 9.23529089,12.502926 C9.23529089,12.502926 11.4147198,0.660975154 14.2987995,0.204290052 C16.8305537,-0.196168429 14.8413182,11.1784768 14.8413182,11.1784768 C14.8413182,11.1784768 16.3254501,10.0095878 18.4581101,9.92181182 C20.8308502,9.82435235 19.8611759,12.1343293 19.8611759,12.1343293 C19.8611759,12.1343293 22.8263216,6.99084307 24.7750241,7.08767781 C27.2163586,7.20887741 25.5357976,12.4229593 25.5357976,12.4229593 C25.5357976,12.4229593 27.3317218,10.7058608 29.2149479,10.463774 C32.900334,9.99053325 28.9873394,14.7145064 28.9873394,14.7145064 C28.9873394,14.7145064 31.6032777,13.6418275 36.1117958,12.9602359 C40.5111865,12.2945752 39.5976348,14.8097793 36.3643476,16.9698186",
    id: "path-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.6840096%",
    y1: "109.209744%",
    x2: "75.8709816%",
    y2: "40.1380578%",
    id: "linearGradient-38"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC3D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE2EF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.7838925,12.6094443 C49.8930198,5.99625664 44.018851,3.91649645 38.3224039,5.7626038 C34.0134329,7.15921056 33.6642254,7.76614569 22.7514914,1.54404546 C19.7021618,-0.195856059 14.0244221,-0.741566642 11.4770782,2.56424624 C9.98671057,4.4990667 9.60632384,7.31289666 10.0210077,9.65567249 C10.4232199,11.9103599 12.0850734,15.1646318 10.2392624,17.1906643 C8.48698913,19.1148642 5.43142361,18.5060548 3.30499944,19.7277343 C1.14427811,20.9687808 0.299320704,23.4777375 0.24943392,25.8408174 C0.130952808,31.3603972 2.21996189,37.5153379 5.9240556,41.5230464 C13.3883657,49.6046859 26.5117078,52.7274499 38.6373142,49.6362353 C65.3735125,42.8209442 55.3182076,28.4303656 52.184694,24.6150771 C48.8111002,20.5130328 49.7090623,17.1691108 49.7838925,12.6094443",
    id: "path-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.7184679%",
    y1: "97.5871956%",
    x2: "27.6842769%",
    y2: "11.7141475%",
    id: "linearGradient-41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6373",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3ED1D1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.6529038,5.66576907 C38.5437765,5.69638134 38.4315312,5.73011731 38.3224039,5.76416565 C34.0134329,7.15764871 33.6642254,7.76739517 22.7514914,1.54279598 C19.6990438,-0.195543689 14.0244221,-0.740629532 11.4801962,2.56487098 C9.98671057,4.49969144 9.60320592,7.31289666 10.0210077,9.6566096 C10.4232199,11.9094228 12.0819555,15.1655689 10.2392624,17.1916014 C8.48698913,19.1148642 5.43454153,18.5054301 3.30811736,19.7283591 C1.14427811,20.9700303 0.299320704,23.4768004 0.246315996,25.8392555 C0.130952808,31.3597725 2.45068826,37.311985 5.9240556,41.5221093 C6.38239043,42.0787529 6.86255072,42.6088449 7.37077233,43.1123855 C19.3436005,50.4012297 6.89372996,34.6577761 16.777549,28.156417 C21.6633359,24.9380678 31.095056,21.5569737 26.9887501,16.4344163 C23.9893073,12.689411 21.7132227,11.2315797 22.6298924,9.17212356 C23.1318782,8.03603346 24.6004204,6.96835243 29.2367733,7.81268883 C35.5786308,8.97126957 40.2087479,6.71845634 38.6529038,5.66576907",
    id: "path-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.5739352%",
    y1: "72.1546705%",
    x2: "26.4073264%",
    y2: "15.6901746%",
    id: "linearGradient-44"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC3D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE2EF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bottomImage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 423,
    height: 117
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-copy-3",
    opacity: 0.180098034,
    transform: "translate(0.000000, 0.463737)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.463737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 27.800940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.55852,29.5830113 C287.98705,35.3896593 275.658779,32.1844296 259.991211,21.720968 C213.804155,-9.12589278 181.116775,-4.9401333 138.081941,22.9114105 C128.91275,28.8458179 114.111653,38.7117154 89.3004613,31.6908848 C52.9891184,21.4157824 15.6438719,31.805837 0.01558962,60.389264 L411.796694,60.389264 C400.076418,38.0582372 356.235289,3.8699533 300.55852,29.5830113",
    id: "Fill-4",
    fill: "url(#linearGradient-4)",
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(83.560363, 54.977139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.067035366,33.2130644 C1.8626478,29.8816371 10.8382156,23.3309236 22.2292392,25.1058105 C34.6632083,27.0440671 37.3954451,22.8167624 42.5213121,21.0590557 C51.9065752,17.8410189 59.1501362,28.4581666 62.3940243,21.7215927 C66.5358746,13.1211065 73.2593659,8.86974929 93.7622105,17.329669 C98.632096,19.3391459 98.2981663,14.8872471 100.51501,12.2873907 C104.819928,7.23917731 110.033097,16.5574901 112.425168,16.0461402 C115.141192,15.4651318 114.312136,11.4986561 115.902901,8.10225593 C119.21663,1.02582344 124.935838,7.67649547 128.878453,7.09236336 C132.803919,6.51135495 134.9054,-1.27696901 139.350001,0.297688715 C148.845638,3.6609777 145.865215,23.4327562 145.27811,27.8434222 C147.978544,24.0796747 152.733378,21.315824 152.733378,33.2130644 L0.067035366,33.2130644",
    id: "Fill-10",
    fill: "url(#linearGradient-7)",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(125.028752, 69.658535)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.970921533,18.5316692 L47.0313892,18.5316692 C49.4250194,9.02156116 40.023855,13.7767714 40.023855,13.7767714 C40.023855,13.7767714 43.5673756,3.77343094 39.9356178,4.81206155 C36.4285768,5.81445724 34.8901931,13.6065296 34.8901931,13.6065296 C34.8901931,13.6065296 33.0007312,0.881196082 28.8576338,0.0471678867 C26.1681125,-0.494481885 28.2786353,12.1461994 28.2786353,12.1461994 C28.2786353,12.1461994 26.691612,10.7958234 24.4080444,10.7611503 C22.489274,10.7320999 22.9538447,13.2004485 22.9538447,13.2004485 C22.9538447,13.2004485 18.9516774,4.99323622 16.867657,5.10006679 C14.2542131,5.2337612 17.056915,13.855801 17.056915,13.855801 C17.056915,13.855801 11.9110933,8.25000699 9.88381908,8.39713331 C7.06646295,8.60111099 11.9781286,16.6065322 11.9781286,16.6065322 C11.9781286,16.6065322 8.2459736,14.3605911 3.80542624,14.7313744 C0.601447539,14.9987632 -0.627949893,16.293225 0.970921533,18.5316692",
    id: "Fill-13",
    fill: "url(#linearGradient-10)",
    mask: "url(#mask-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(328.940982, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2653918,35.998781 C26.2653918,55.788677 18.4051054,71.9738219 12.9549742,71.9738219 C7.50172514,71.9738219 0.277495236,50.3681185 0.277495236,30.5785349 C0.277495236,10.7886389 9.10433808,-1.97136777 15.4461955,0.308934039 C22.5955952,2.8781782 26.2653918,16.2091974 26.2653918,35.998781",
    id: "Fill-16",
    fill: "url(#linearGradient-13)",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(224.802320, 16.867986)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-19",
    fill: "url(#linearGradient-16)",
    mask: "url(#mask-15)",
    points: "42.1169174 71.3222179 0.0395976348 71.3222179 0.0395976348 29.1678714 21.0777898 0.153061354 42.1169174 29.1678714 42.1169174 71.3222179"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#F7CE8F",
    points: "266.919238 88.1902038 316.540998 88.1902038 316.540998 46.0358574 266.919238 46.0358574"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(274.689104, 53.727659)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "url(#linearGradient-19)",
    mask: "url(#mask-18)",
    points: "0.165249972 34.4625448 48.4650106 34.4625448 48.4650106 0.0203040572 0.165249972 0.0203040572"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "url(#linearGradient-20)",
    points: "323.154115 88.1902038 372.775875 88.1902038 372.775875 53.7479631 323.154115 53.7479631"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#9D9D9C",
    points: "281.467471 88.1902038 316.540998 88.1902038 316.540998 61.5097356 281.467471 61.5097356"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(245.692411, 16.867986)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-30"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-29",
    fill: "url(#linearGradient-23)",
    mask: "url(#mask-22)",
    points: "0.187699025 0.153061354 49.8119538 0.153061354 70.848587 29.1678714 21.2268266 29.1678714 0.187699025 0.153061354"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#F7CE8F",
    points: "281.467471 88.1902038 283.515947 88.1902038 283.515947 61.5097356 281.467471 61.5097356"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#415680",
    points: "283.515947 62.0938677 316.540998 62.0938677 316.540998 61.5097356 283.515947 61.5097356"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#415680",
    points: "283.515947 64.268276 316.540998 64.268276 316.540998 63.6844563 283.515947 63.6844563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#415680",
    points: "283.515947 66.4429967 316.540998 66.4429967 316.540998 65.859177 283.515947 65.859177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-36",
    fill: "#415680",
    points: "283.515947 68.6177174 316.540998 68.6177174 316.540998 68.0338977 283.515947 68.0338977"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#415680",
    points: "283.515947 70.7924382 316.540998 70.7924382 316.540998 70.2086184 283.515947 70.2086184"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#415680",
    points: "283.515947 72.9671589 316.540998 72.9671589 316.540998 72.3833391 283.515947 72.3833391"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#415680",
    points: "283.515947 75.1418796 316.540998 75.1418796 316.540998 74.5580598 283.515947 74.5580598"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#415680",
    points: "283.515947 77.3166003 316.540998 77.3166003 316.540998 76.7330929 283.515947 76.7330929"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#415680",
    points: "283.515947 79.491321 316.540998 79.491321 316.540998 78.9078136 283.515947 78.9078136"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#415680",
    points: "283.515947 81.6660417 316.540998 81.6660417 316.540998 81.0825343 283.515947 81.0825343"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#415680",
    points: "283.515947 83.8407624 316.540998 83.8407624 316.540998 83.257255 283.515947 83.257255"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#415680",
    points: "283.515947 86.0154831 316.540998 86.0154831 316.540998 85.4316634 283.515947 85.4316634"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#415680",
    points: "283.515947 88.1902038 316.540998 88.1902038 316.540998 87.6063841 283.515947 87.6063841"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#2E3E5C",
    points: "233.731119 80.428119 242.581035 80.428119 242.581035 53.7479631 233.731119 53.7479631"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#F7CE8F",
    points: "233.731119 80.428119 235.778348 80.428119 235.778348 53.7479631 233.731119 53.7479631"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#2E3E5C",
    points: "249.179186 88.1902038 258.030036 88.1902038 258.030036 53.7479631 249.179186 53.7479631"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#F7CE8F",
    points: "249.179186 88.1902038 251.226103 88.1902038 251.226103 53.7479631 249.179186 53.7479631"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#F7CE8F",
    points: "284.248659 46.0358574 299.208459 46.0358574 299.208459 26.1078938 284.248659 26.1078938"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#2E3E5C",
    points: "287.304225 46.0358574 296.152893 46.0358574 296.152893 31.6708931 287.304225 31.6708931"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#FFFFFF",
    points: "294.076356 46.0358574 296.152893 46.0358574 296.152893 31.6708931 294.076356 31.6708931"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(270.324011, 25.926719)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-54"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-53",
    fill: "url(#linearGradient-26)",
    mask: "url(#mask-25)",
    points: "13.9246486 0.181174664 0.246315996 0.181174664 13.9246486 20.1091382 13.9246486 0.181174664"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#36A9E1",
    points: "237.760101 80.428119 242.581035 80.428119 242.581035 58.1248931 237.760101 58.1248931"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#36A9E1",
    points: "253.206608 88.1902038 258.030036 88.1902038 258.030036 58.1248931 253.206608 58.1248931"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#FFFFFF",
    points: "251.226103 62.6773751 258.030036 62.6773751 258.030036 61.5097356 251.226103 61.5097356"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#FFFFFF",
    points: "235.778348 62.6773751 242.581035 62.6773751 242.581035 61.5097356 235.778348 61.5097356"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#36A9E1",
    points: "289.256045 46.0358574 294.076356 46.0358574 294.076356 36.0475108 289.256045 36.0475108"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-61",
    fill: "#FFFFFF",
    points: "202.115058 88.1902038 201.240169 88.1902038 201.240169 78.6800958 202.636063 78.6800958 202.115058 88.1902038"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-62",
    fill: "#FFFFFF",
    points: "207.40524 88.1902038 206.57556 88.1902038 205.065238 78.6800958 206.461444 78.6800958 207.40524 88.1902038"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-63",
    fill: "#FFFFFF",
    points: "207.420829 70.5397307 206.689364 70.5397307 205.065238 78.6800958 206.461444 78.6800958 207.420829 70.5397307"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#FFFFFF",
    points: "201.240169 80.4471735 206.461444 80.4471735 206.461444 78.6800958 201.240169 78.6800958"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-65",
    fill: "#FFFFFF",
    points: "203.901629 80.4471735 207.726698 80.4471735 207.726698 78.6800958 203.901629 78.6800958"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-66",
    fill: "#FFFFFF",
    points: "179.573715 88.1902038 178.698825 88.1902038 178.698825 78.6800958 180.094408 78.6800958 179.573715 88.1902038"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-67",
    fill: "#FFFFFF",
    points: "184.863585 88.1902038 184.033905 88.1902038 182.523895 78.6800958 183.919789 78.6800958 184.863585 88.1902038"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-68",
    fill: "#FFFFFF",
    points: "184.879486 70.5397307 184.148021 70.5397307 182.523895 78.6800958 183.919789 78.6800958 184.879486 70.5397307"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    fill: "#FFFFFF",
    points: "178.698825 80.4471735 183.919789 80.4471735 183.919789 78.6800958 178.698825 78.6800958"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#FFFFFF",
    points: "176.769142 80.4471735 203.901629 80.4471735 203.901629 78.6800958 176.769142 78.6800958"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-71",
    fill: "#FFFFFF",
    points: "181.456629 72.3068084 208.588804 72.3068084 208.909015 70.5397307 181.77684 70.5397307 181.456629 72.3068084"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-72",
    fill: "#FFFFFF",
    points: "180.964621 75.0203676 208.097107 75.0203676 208.417318 73.2529775 181.285143 73.2529775 180.964621 75.0203676"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-75",
    transform: "translate(142.177334, 13.431915)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3840111,16.8651746 C50.2914905,15.099034 48.0762055,13.4141097 45.2728801,13.0036553 C40.5984884,12.3198772 42.2026603,7.13484569 38.1396935,5.7626038 C33.8553542,4.31508071 33.4942986,7.76614569 22.5376018,1.54404546 C19.4745533,-0.195856059 13.7936958,-0.741566642 11.271607,2.56424624 C9.79527004,4.4990667 9.43359085,7.31289666 9.86729408,9.65567249 C10.2841605,11.9103599 11.9687749,15.1646318 10.1382417,17.1906643 C8.39968725,19.1148642 5.34193919,18.5060548 3.224557,19.7277343 C1.07318944,20.9687808 0.243821657,23.4777375 0.211083455,25.8408174 C0.134382524,31.3603972 2.4983925,37.3116726 5.99950936,41.5230464 C13.2963869,50.2993971 26.4446724,52.3975871 36.8273593,48.6179087 C42.9628102,46.3847748 47.763166,41.836666 50.5646207,35.9494265 C53.2310693,30.3470686 54.8567548,22.4844006 51.3840111,16.8651746",
    id: "Fill-73",
    fill: "url(#linearGradient-29)",
    mask: "url(#mask-28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    transform: "translate(142.177334, 13.431915)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1143719,5.38182463 C32.8011841,5.49146654 30.3904052,6.00656486 22.5366665,1.54279598 C19.4754887,-0.195543689 13.7952547,-0.740629532 11.2709835,2.56487098 C9.796829,4.49969144 9.43390264,7.31289666 9.86854125,9.6566096 C10.2841605,11.9094228 11.970022,15.1655689 10.1369945,17.1916014 C8.39844008,19.1148642 5.34100381,18.5054301 3.224557,19.7283591 C1.07412482,20.9700303 0.242574487,23.4768004 0.212642417,25.8392555 C0.133135355,31.3597725 2.49901609,37.311985 5.99857398,41.5221093 C6.33499798,41.9272533 6.68264651,42.3174036 7.04557286,42.6919354 C20.2237904,49.8745737 10.6810722,27.97493 15.0801512,23.9990832 C17.8657045,21.4813801 23.3117824,25.0480221 25.7796192,23.2800072 C27.011511,22.397874 26.9132964,20.6520375 25.9532876,19.323215 C22.9903244,15.2299171 18.2283191,10.8720417 20.5829753,8.39557146 C21.8413694,7.07049745 24.3472449,7.7973827 29.0674701,7.81268883 C34.5210309,7.82799497 37.3327748,6.41920577 35.1143719,5.38182463",
    id: "Fill-76",
    fill: "url(#linearGradient-32)",
    mask: "url(#mask-31)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-79",
    fill: "#2E3E5C",
    points: "171.388541 88.1902038 168.686548 88.1902038 168.57742 70.3979147 165.617575 42.7166126 166.325032 41.8172991 170.183463 68.8301291 172.930042 51.0512719 173.592913 51.7406727 170.893103 71.9657003 171.388541 88.1902038"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-80",
    fill: "#2E3E5C",
    points: "178.411665 49.5834448 172.112834 58.8914493 172.112834 58.1248931 178.053415 49.2167222 178.411665 49.5834448"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-81",
    fill: "#2E3E5C",
    points: "167.43439 56.8326179 162.068442 49.5525201 162.364957 49.2167222 167.547258 55.9376775 167.43439 56.8326179"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-82",
    fill: "#2E3E5C",
    points: "168.758572 41.3284398 167.176225 50.0810503 166.822653 49.2167222 168.397516 41.2184856 168.758572 41.3284398"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(327.070228, 71.845125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6326325,16.3450784 C79.2576281,13.0136512 72.3919594,6.46293759 63.6804798,8.23782456 C54.1676936,10.1760811 52.0786846,5.94877639 48.1563362,4.19106977 C40.9788751,0.973032894 37.4431493,8.95721292 32.9564567,4.85360678 C26.6894294,-0.87588579 21.6134492,-1.46033027 17.5663838,3.81966171 C11.7483376,11.4121296 2.21060812,3.00468809 0.068594328,16.3450784 L80.6326325,16.3450784",
    id: "Fill-83",
    fill: "url(#linearGradient-35)",
    mask: "url(#mask-34)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-88",
    transform: "translate(355.131544, 71.220385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3643476,16.9698186 L0.074830176,16.9698186 C0.28061316,5.8441324 3.20210795,12.9861626 3.20210795,12.9861626 C3.20210795,12.9861626 4.16242854,4.855481 6.28573478,4.52593053 C8.29055991,4.21449753 9.23529089,12.502926 9.23529089,12.502926 C9.23529089,12.502926 11.4147198,0.660975154 14.2987995,0.204290052 C16.8305537,-0.196168429 14.8413182,11.1784768 14.8413182,11.1784768 C14.8413182,11.1784768 16.3254501,10.0095878 18.4581101,9.92181182 C20.8308502,9.82435235 19.8611759,12.1343293 19.8611759,12.1343293 C19.8611759,12.1343293 22.8263216,6.99084307 24.7750241,7.08767781 C27.2163586,7.20887741 25.5357976,12.4229593 25.5357976,12.4229593 C25.5357976,12.4229593 27.3317218,10.7058608 29.2149479,10.463774 C32.900334,9.99053325 28.9873394,14.7145064 28.9873394,14.7145064 C28.9873394,14.7145064 31.6032777,13.6418275 36.1117958,12.9602359 C40.5111865,12.2945752 39.5976348,14.8097793 36.3643476,16.9698186",
    id: "Fill-86",
    fill: "url(#linearGradient-38)",
    mask: "url(#mask-37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-91",
    transform: "translate(336.735792, 13.431915)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7838925,12.6094443 C49.8930198,5.99625664 44.018851,3.91649645 38.3224039,5.7626038 C34.0134329,7.15921056 33.6642254,7.76614569 22.7514914,1.54404546 C19.7021618,-0.195856059 14.0244221,-0.741566642 11.4770782,2.56424624 C9.98671057,4.4990667 9.60632384,7.31289666 10.0210077,9.65567249 C10.4232199,11.9103599 12.0850734,15.1646318 10.2392624,17.1906643 C8.48698913,19.1148642 5.43142361,18.5060548 3.30499944,19.7277343 C1.14427811,20.9687808 0.299320704,23.4777375 0.24943392,25.8408174 C0.130952808,31.3603972 2.21996189,37.5153379 5.9240556,41.5230464 C13.3883657,49.6046859 26.5117078,52.7274499 38.6373142,49.6362353 C65.3735125,42.8209442 55.3182076,28.4303656 52.184694,24.6150771 C48.8111002,20.5130328 49.7090623,17.1691108 49.7838925,12.6094443",
    id: "Fill-89",
    fill: "url(#linearGradient-41)",
    mask: "url(#mask-40)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-94",
    transform: "translate(336.735792, 13.431915)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-43",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6529038,5.66576907 C38.5437765,5.69638134 38.4315312,5.73011731 38.3224039,5.76416565 C34.0134329,7.15764871 33.6642254,7.76739517 22.7514914,1.54279598 C19.6990438,-0.195543689 14.0244221,-0.740629532 11.4801962,2.56487098 C9.98671057,4.49969144 9.60320592,7.31289666 10.0210077,9.6566096 C10.4232199,11.9094228 12.0819555,15.1655689 10.2392624,17.1916014 C8.48698913,19.1148642 5.43454153,18.5054301 3.30811736,19.7283591 C1.14427811,20.9700303 0.299320704,23.4768004 0.246315996,25.8392555 C0.130952808,31.3597725 2.45068826,37.311985 5.9240556,41.5221093 C6.38239043,42.0787529 6.86255072,42.6088449 7.37077233,43.1123855 C19.3436005,50.4012297 6.89372996,34.6577761 16.777549,28.156417 C21.6633359,24.9380678 31.095056,21.5569737 26.9887501,16.4344163 C23.9893073,12.689411 21.7132227,11.2315797 22.6298924,9.17212356 C23.1318782,8.03603346 24.6004204,6.96835243 29.2367733,7.81268883 C35.5786308,8.97126957 40.2087479,6.71845634 38.6529038,5.66576907",
    id: "Fill-92",
    fill: "url(#linearGradient-44)",
    mask: "url(#mask-43)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-95",
    fill: "#2E3E5C",
    points: "365.065249 88.1902038 367.768489 88.1902038 367.531527 70.3979147 368.108343 41.3284398 367.409928 40.4291263 365.938268 68.8301291 361.94109 51.378011 361.273854 52.0677242 365.205556 71.9657003 365.065249 88.1902038"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-96",
    fill: "#2E3E5C",
    points: "372.086814 45.3833163 367.494112 52.2454628 367.484758 53.6142687 372.563857 45.7931458 372.086814 45.3833163"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-97",
    fill: "#2E3E5C",
    points: "365.255443 42.7747135 367.266504 46.8570784 367.260268 47.7388993 364.949886 42.9015357 365.255443 42.7747135"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-98",
    fill: "#2E3E5C",
    points: "359.134958 53.7026694 362.517905 56.7360955 362.795401 57.51296 358.844991 53.9153934 359.134958 53.7026694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.344973,88.1902038 C352.415832,85.8652331 351.452393,84.1678139 350.666676,84.3567978 C349.890313,84.5432828 349.678294,86.0948251 349.762478,88.1902038 L353.344973,88.1902038",
    id: "Fill-99",
    fill: "#3FC3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.586167,88.1902038 C346.223635,87.3018232 344.7738,86.4037592 343.520395,86.2759998 C342.229574,86.144492 341.955197,87.143764 341.808654,88.1902038 L347.586167,88.1902038",
    id: "Fill-100",
    fill: "#3FC3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.621551,88.1902038 C123.813074,87.1584454 122.435575,86.4581116 121.183105,86.3300398 C119.891973,86.1988444 119.018018,87.2274791 119.387804,88.1902038 L124.621551,88.1902038",
    id: "Fill-101",
    fill: "#6CE3F0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomImage);
export default __webpack_public_path__ + "static/media/bottomImage.59b2d810ffeb4d95205b53bca172b6c3.svg";
export { ForwardRef as ReactComponent };